export default __webpack_public_path__ + "static/media/WorkSans-Light.6c55d510.ttf";